import { normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-8937f682"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "theme-toggle" }
const _hoisted_2 = ["aria-label", "title", "onClick"]
const _hoisted_3 = {
  key: 0,
  width: "18",
  height: "18",
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("rect", {
  x: "2",
  y: "3",
  width: "20",
  height: "14",
  rx: "2",
  ry: "2"
}, null, -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("line", {
  x1: "8",
  y1: "21",
  x2: "16",
  y2: "21"
}, null, -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("line", {
  x1: "12",
  y1: "17",
  x2: "12",
  y2: "21"
}, null, -1))
const _hoisted_7 = [
  _hoisted_4,
  _hoisted_5,
  _hoisted_6
]
const _hoisted_8 = {
  key: 1,
  width: "18",
  height: "18",
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}
const _hoisted_9 = /*#__PURE__*/_createStaticVNode("<circle cx=\"12\" cy=\"12\" r=\"5\" data-v-8937f682></circle><line x1=\"12\" y1=\"1\" x2=\"12\" y2=\"3\" data-v-8937f682></line><line x1=\"12\" y1=\"21\" x2=\"12\" y2=\"23\" data-v-8937f682></line><line x1=\"4.22\" y1=\"4.22\" x2=\"5.64\" y2=\"5.64\" data-v-8937f682></line><line x1=\"18.36\" y1=\"18.36\" x2=\"19.78\" y2=\"19.78\" data-v-8937f682></line><line x1=\"1\" y1=\"12\" x2=\"3\" y2=\"12\" data-v-8937f682></line><line x1=\"21\" y1=\"12\" x2=\"23\" y2=\"12\" data-v-8937f682></line><line x1=\"4.22\" y1=\"19.78\" x2=\"5.64\" y2=\"18.36\" data-v-8937f682></line><line x1=\"18.36\" y1=\"5.64\" x2=\"19.78\" y2=\"4.22\" data-v-8937f682></line>", 9)
const _hoisted_18 = [
  _hoisted_9
]
const _hoisted_19 = {
  key: 2,
  width: "18",
  height: "18",
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("path", { d: "M21 12.79A9 9 0 1 1 11.21 3 7 7 0 0 0 21 12.79z" }, null, -1))
const _hoisted_21 = [
  _hoisted_20
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: _normalizeClass(["theme-toggle__indicator", `theme-toggle__indicator--${_ctx.themePreference}`])
    }, null, 2),
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.options, (option) => {
      return (_openBlock(), _createElementBlock("button", {
        key: option.mode,
        class: _normalizeClass(["theme-toggle__option", { 'theme-toggle__option--active': _ctx.themePreference === option.mode }]),
        "aria-label": option.label,
        title: option.label,
        onClick: ($event: any) => (_ctx.setTheme(option.mode))
      }, [
        (option.mode === 'system')
          ? (_openBlock(), _createElementBlock("svg", _hoisted_3, _hoisted_7))
          : _createCommentVNode("", true),
        (option.mode === 'light')
          ? (_openBlock(), _createElementBlock("svg", _hoisted_8, _hoisted_18))
          : _createCommentVNode("", true),
        (option.mode === 'dark')
          ? (_openBlock(), _createElementBlock("svg", _hoisted_19, _hoisted_21))
          : _createCommentVNode("", true)
      ], 10, _hoisted_2))
    }), 128))
  ]))
}